import { useEffect } from 'react';

/**
 * Marks `document.body` with `data-has-blocking-dialog` while a blocking dialog is open.
 * The count of open blocking dialogs is kept in the attribute value itself, so with multiple
 * blocking dialogs stacked do not clear the flag while another is still open.
 */
export function useBlockingDialogBodyFlag(isBlocking?: boolean, open?: boolean) {
  useEffect(() => {
    if (!isBlocking || !open) return;

    document.body.dataset.hasBlockingDialog = String(Number(document.body.dataset.hasBlockingDialog || 0) + 1);

    return () => {
      const count = Number(document.body.dataset.hasBlockingDialog || 0) - 1;
      if (count <= 0) {
        delete document.body.dataset.hasBlockingDialog;
      } else {
        document.body.dataset.hasBlockingDialog = String(count);
      }
    };
  }, [isBlocking, open]);
}
